<template>
	<div
		v-bind="getAttrs($attrs)"
		class="WurldTextarea"
	>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-html="label"
			v-if="label && !labelAfter"
			:for="guid"
		></label>
		<textarea
			v-bind="getAttrs($attrs, 'textarea')"
			@input="$emit('input', $event.target.value)"
			:id="label || uid ? guid : null"
			:name="name"
			:value="value"
		></textarea>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-html="label"
			v-if="label && labelAfter"
			:for="guid"
		></label>
	</div>
</template>

<script>
export default {
	name: 'WurldTextarea',
	inheritAttrs: false,
	props: {
		label: {
			default: null,
			type: String
		},
		labelAfter: {
			default: false,
			type: Boolean
		},
		name: {
			default: null,
			type: String
		},
		uid: {
			default: null,
			type: String
		},
		value: {
			default: null,
			type: String
		}
	},
	data () {
		return {
			guid: ''
		};
	},
	mounted () {
		this.guid = this.uid ? this.uid : this.generateUID('WurldTextarea');
	}
};
</script>
